import { useMemo, useState } from "react";
import Loading from "_shared/components/Loading/Loading";
import Switch from "_shared/components/Switch/Switch";
import LineChart from "_shared/components/TradingView/LineChart";
import { useChartDataQuery } from "_shared/graphql";
import styles from "../Chart.module.scss";
import { massageData } from "../utilities";

interface Props {
  ticker: string;
}

const formatDate = (date: Date) => date.toLocaleDateString("fr-CA");

function PriceReturns({ ticker }: Props) {
  const [isIntraday, setIsIntraday] = useState(false);

  const lastYear = new Date(Date.now() - 356 * 24 * 60 * 60 * 1000);
  const variables = {
    ticker,
    from: formatDate(lastYear),
    to: formatDate(new Date()),
    interval: isIntraday ? "intraday" : "daily",
    fields: ["current_trr_ytd", "timestamp"],
  };
  const { data, loading } = useChartDataQuery({ variables });

  const chartData = useMemo(
    () =>
      data?.get_charting_data?.data
        ? massageData(data.get_charting_data.data, "current_trr_ytd")
        : null,
    [data],
  );

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h3 className={styles.title}>Price returns</h3>
        <Switch
          checked={isIntraday}
          onCheckedChange={setIsIntraday}
          name="intraday"
          label="Intraday"
          className={styles.switch}
        />
      </div>
      <div className={styles.graphContainer}>
        {chartData ? (
          <LineChart
            data={chartData}
            curvedLines
            showTime={isIntraday}
            ticker={ticker}
          />
        ) : (
          <div className={styles.graphState}>
            {loading ? <Loading variant="inner" /> : "Error loading data"}
          </div>
        )}
      </div>
    </div>
  );
}

export default PriceReturns;
